export const INFO_MESSAGE_CATEGORY_KEY = 'message' as const;
export const INFO_MESSAGE_COMPONENT_KEY = 'infoMessage' as const;
